import { useNavigate } from 'react-router-dom';
import type { JSX } from 'react';
import { updatedImageUrl } from '@/utils/formatting';
import styles from './CollectionCard.module.css';
import type { CollectionCardProps, ImageItem } from './CollectionCard.types';

const CollectionCard = ({
  id,
  products,
  title = 'All saves',
  images = [],
  totalSaves = 0,
}: CollectionCardProps): JSX.Element => {
  // Transform image URLs using the same logic as ProductCard
  const transformImages = (imageArray: ImageItem[]): ImageItem[] => {
    return imageArray.map((item) => ({
      ...item,
      url: updatedImageUrl(item.url),
    }));
  };

  const transformedImages = transformImages(images);
  const items: ImageItem[] = transformedImages.slice(0, 3);

  const navigate = useNavigate();

  return (
    <div
      className={styles.container}
      onClick={() =>
        navigate(`/slaylist/${id}`, { state: { products, id, title } })
      }
    >
      {/* Grid Container */}
      <div className={styles.gridContainer}>
        {/* Left side - single large image */}
        <div className={styles.leftImage}>
          {items[0] && items[0].url && (
            <img
              src={items[0].url}
              alt={items[0].title || 'Save 1'}
              className={styles.image}
              loading="lazy"
            />
          )}
        </div>

        {/* Right side - two images stacked */}
        <div className={styles.rightContainer}>
          {/* Top right image */}
          <div className={styles.topRightImage}>
            {items[1] && items[1].url && (
              <img
                src={items[1].url}
                alt={items[1].title || 'Save 2'}
                className={styles.image}
                loading="lazy"
              />
            )}
          </div>

          {/* Bottom right - single image */}
          <div className={styles.bottomRightImage}>
            {items[2] && (
              <img
                src={items[2].url}
                alt={items[2].title || 'Save 3'}
                className={styles.image}
                loading="lazy"
              />
            )}
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.title}>{title}</div>
        <p className={styles.subtitle}>{totalSaves} Saves</p>
      </div>
    </div>
  );
};

export default CollectionCard;
